<template lang="pug">
.boolean-field.form-field-radio
  .form-field-radio-label.form-field-label(v-if="label")
    span {{ label }}
    q-icon.cancel-select-field(name="cancel", v-if="checkIfCanCancel && !isDisabled", @click.stop="resetValue()")

  .radio-row.form-radio
    q-radio(:value="value", :val="true", :label="issueCenterLocales.yes", :disable="isDisabled", @input="changeValue")
    q-radio(:value="value", :val="false", :label="issueCenterLocales.no", :disable="isDisabled", @input="changeValue")
</template>

<script setup>
import { ref, computed, onMounted, watch } from "vue";
import { issueCenterLocales } from "@/services/useLocales";

const props = defineProps({
  /* Лейбл чекбокса, строка */
  label: { type: String || null, default: null, required: false },
  /* Начальное значение поля, булеан или пустое значение, которое отображается на форме как незаполненное поле типа false */
  initialValue: { type: Boolean || null, default: null, required: false },
  /** Запрещает изменение значения в show/readonly режимах. */
  readonly: { type: Boolean, default: false, required: false },
  /** Совместимость с компонентами, которые передают disable вместо readonly. */
  disable: { type: Boolean, default: false, required: false },
});

const emit = defineEmits(["change"]);

const value = ref(props.initialValue);

const checkIfCanCancel = computed(() => value.value === true || value.value === false);
const isDisabled = computed(() => props.readonly || props.disable);

const changeValue = val => {
  if (isDisabled.value) {
    return;
  }

  value.value = val;
  emit("change", { value: val });
};

const resetValue = () => {
  changeValue(null);
};

onMounted(() => {
  emit("change", { value: props.initialValue });
});

watch(
  () => props.initialValue,
  newValue => {
    value.value = newValue;
  },
);
</script>
